// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"3d8784ec","84":"838f5439","148":"49055386","252":"367a3b37","284":"2dd184ad","297":"77e5c413","338":"942db9a9","360":"5ab049e8","453":"3692bc5d","497":"d0ae529b","533":"06db6b98","635":"72b67688","699":"8d7081c7","733":"d02093cc"}[chunkId] + ".chunk.js";
};